import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    heading: "What We Collect",
    body: [
      "To provide the tracking service, we collect the item names and dates you add to your pantry — whether you scan them with your camera or type them in. This is the core data the app needs to count down to expiry and remind you in time.",
      "If you join our launch waitlist, we collect your email address. If you contact us for support, we collect your name, email address, and the contents of your message.",
    ],
  },
  {
    heading: "How We Use Your Information",
    body: [
      "Item names and dates are used solely to run the tracking service: showing your pantry, counting down to expiry, and sending you reminders.",
      "Email addresses are used to send the launch updates you asked for and to reply to your support messages. That’s all.",
    ],
  },
  {
    heading: "How We Store Your Data",
    body: [
      "Your data is stored securely. It is encrypted in transit and at rest, and access to it is limited to what is needed to operate and improve the service.",
    ],
  },
  {
    heading: "What We Never Do",
    highlight: true,
    body: [
      "We do not sell your information to third parties. Ever.",
      "We do not rent, trade, or share your personal data with advertisers, data brokers, or anyone else. We do not run advertising trackers or build advertising profiles about you.",
      "Your grocery list is yours. It exists to serve you — no one else.",
    ],
  },
  {
    heading: "Your Rights",
    body: [
      "You can ask us at any time to show you the data we hold about you, correct it, or delete it entirely. To do any of these, email myfreshtracker@gmail.com and we will take care of it.",
      "If you joined the waitlist and change your mind, tell us and we will remove your address from the list.",
    ],
  },
  {
    heading: "Data Retention",
    body: [
      "We keep your data only for as long as your account or signup is active. When you ask us to delete it, we remove it from our systems.",
    ],
  },
  {
    heading: "Changes to This Policy",
    body: [
      "If we change this Privacy Policy, we will post the updated version on this page with a new “last updated” date. Significant changes will be flagged clearly.",
    ],
  },
  {
    heading: "Contact Us",
    body: [
      "Questions about your privacy? Write to us at myfreshtracker@gmail.com — a human will reply.",
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalPage
      testid="privacy-page"
      title="Privacy Policy"
      subtitle="We value your privacy. Here is exactly what we collect, why we collect it, and what we will never do with it."
      updated="August 2026"
      sections={SECTIONS}
    />
  );
}
